export const INP =
  "h-8 w-full min-w-0 rounded-md border border-gray-200 bg-white px-2 text-sm focus:border-primary focus:outline-none";

export function CollapsibleBlock({ title, subtitle, open, onToggle, children }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between gap-2 bg-gray-50/80 px-3 py-2.5">
        <button
          type="button"
          onClick={onToggle}
          className="flex min-w-0 flex-1 items-center gap-2 text-left hover:opacity-80"
        >
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-gray-900">{title}</p>
            {subtitle ? <p className="truncate text-xs text-gray-500">{subtitle}</p> : null}
          </div>
        </button>
        <button type="button" onClick={onToggle} className="p-1 text-gray-400 hover:text-gray-600">
          <i className={`fi fi-rr-angle-small-${open ? "up" : "down"}`} />
        </button>
      </div>
      {open ? <div className="border-t border-gray-100 p-2 sm:p-3">{children}</div> : null}
    </div>
  );
}

export function PriceTable({ columns, children }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[480px] border-collapse text-sm">
        <thead>
          <tr className="border-b border-gray-100 text-left">
            {columns.map((col) => (
              <th
                key={col}
                className="pb-1.5 pr-2 text-[10px] font-bold uppercase tracking-wide text-gray-500"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">{children}</tbody>
      </table>
    </div>
  );
}
